import React, { useState, useEffect, Fragment } from "react";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import Counter from "../UI/Counter";
import moment from "moment/moment";

import {
  fetchCitiesAsync,
  fetchHotelSearchPrice,
  fetchSingleHotelData,
  getCountriesAsync,
  getCountryList,
  getHotelCities,
  getHotelRejected,
  getLoading,
  hotelSearchAsync,
  resetRejected,
  setCounts,
} from "../../features/bookings/hotelSlice";

import _ from "lodash";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import Loader from "../../helpers/Loader";
import SearchButton from "../UI/SearchButton";
import { errorToast } from "../../helpers/toaster";
import { slashFormatter } from "../../helpers/helper";

const HotelForm = () => {
  const [searchParams] = useSearchParams();
  const queryData = Object.fromEntries([...searchParams]);

  const { Authorization } =
    JSON.parse(sessionStorage.getItem("userData")) || {};

  const c = queryData.city !== undefined ? queryData.city : "";
  const ci = queryData.checkIn !== undefined ? queryData.checkIn : "";
  const co = queryData.checkOut !== undefined ? queryData.checkOut : "";
  const nat =
    queryData.Nationality !== undefined ? queryData.Nationality : "AE";

  const [state, setState] = useState({
    checkIn: ci,
    checkOut: co,
    city: c,
    Nationality: nat,
    guestDetails: [],
  });
  var [guestDetails, setGuestDetails] = useState([
    { Adults: 1, Children: 0, ChildrenAges: [] },
  ]);

  const [inputActive, setInputActive] = useState(false);

  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [listShow, setListShow] = useState(false);
  const [ageDrop, setAgeDrop] = useState("");
  const [city, setCity] = useState(c);
  const [childs, setChilds] = useState([]);
  const [changed, setChanged] = useState(false);
  const rejected = useSelector(getHotelRejected);
  const checkRef = React.useRef(true);

  const [placeHolder, setPlaceHolder] = useState("1 Adult - 0 Child, 1 Room");

  const [startCheckIn, setStartCheckIn] = useState(
    new Date().setFullYear(new Date().getFullYear()),
  );
  const endDateAll = new Date().setFullYear(new Date().getFullYear() + 1);

  const [startCheckOut, setStartCheckOut] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const todayMinDate = new Date().setFullYear(new Date().getFullYear());
  const loading = useSelector(getLoading);

  useEffect(() => {}, [searchParams]);

  useEffect(() => {
    if (new Date(startCheckIn) >= new Date(startCheckOut)) {
      setStartCheckOut(new Date().getFullYear() + startCheckIn);
    }
  }, [startCheckIn]);

  useEffect(() => {
    if (rejected === true) {
      navigate("/hotel");
      dispatch(resetRejected());
    }
  }, [rejected]);

  const cities = useSelector(getHotelCities);
  const countryList = useSelector(getCountryList);

  useEffect(() => {
    if (city?.length > 1) {
      dispatch(fetchCitiesAsync({ city, Authorization }));
      changed === false && setListShow(true);
    } else {
      setListShow(false);
    }
  }, [city]);

  useEffect(() => {
    setList(cities);
    listShow ? setListShow(true) : setListShow(false);
  }, [cities, listShow]);

  useEffect(() => {
    if (window.location.pathname.includes("/hotel")) {
      if (Object.keys(queryData).length > 0) {
        const guestDetails = JSON.parse(queryData.guestDetails);
        setState(queryData);
        dispatch(setCounts(guestDetails));

        setCity(queryData.cityname);
        setChanged(true);

        let x = JSON.parse(JSON.stringify(guestDetails));
        setGuestDetails(x);

        var val = guestDetails.reduce(function (previousValue, currentValue) {
          return {
            Adults: previousValue.Adults + currentValue.Adults,
            Children: previousValue.Children + currentValue.Children,
          };
        });

        setPlaceHolder(
          `${val.Adults} Adult - ${val.Children} Child, ${guestDetails?.length} Room`,
        );

        dispatch(setCounts(guestDetails));

        let ci = queryData.checkIn;

        setStartCheckIn(
          new Date(ci).getTime() - new Date(ci).getTimezoneOffset() * 60000,
        );
        let co = queryData.checkOut;
        setStartCheckOut(
          new Date(co).getTime() - new Date(co).getTimezoneOffset() * 60000,
        );

        sessionStorage.setItem("hotelForm", JSON.stringify(queryData));
      } else {
        const sessionData = JSON.parse(sessionStorage.getItem("hotelForm"));

        if (sessionData !== null && sessionData !== undefined) {
          const guestDetails = JSON.parse(sessionData.guestDetails);

          setTimeout(() => {
            setState(sessionData);
          }, 300);

          setCity(sessionData.cityname);
          setChanged(true);

          dispatch(setCounts(guestDetails));

          var val = guestDetails.reduce(function (previousValue, currentValue) {
            return {
              Adults: previousValue.Adults + currentValue.Adults,
              Children: previousValue.Children + currentValue.Children,
            };
          });

          setPlaceHolder(
            `${val.Adults} Adult - ${val.Children} Child, ${guestDetails?.length} Room`,
          );

          let ci = sessionData.checkIn;

          setStartCheckIn(
            new Date(ci).getTime() - new Date(ci).getTimezoneOffset() * 60000,
          );
          let co = sessionData.checkOut;
          setStartCheckOut(
            new Date(co).getTime() - new Date(co).getTimezoneOffset() * 60000,
          );
        }
      }
    }
  }, [searchParams]);

  const handleApplyBtn = () => {
    setAgeDrop("");
    dispatch(setCounts(guestDetails));
    var val = guestDetails.reduce(function (previousValue, currentValue) {
      return {
        Adults: previousValue.Adults + currentValue.Adults,
        Children: previousValue.Children + currentValue.Children,
      };
    });
    setPlaceHolder(
      `${val.Adults} Adult - ${val.Children} Child, ${guestDetails?.length} Room`,
    );
  };

  useEffect(() => {
    setState({
      ...state,
      cityname: city,
      guestDetails: JSON.stringify(guestDetails),
    });
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      handleApplyBtn();

      let val = state;
      sessionStorage.setItem("hotelForm", JSON.stringify(val));

      loading ? (
        <Loader />
      ) : (
        <Fragment>
          {navigate({
            pathname: "/hotel-listing",
            search: `${createSearchParams(state)}`,
          })}
        </Fragment>
      );

      setIsSubmit(false);
    }
  }, [formErrors, isSubmit, guestDetails]);

  useEffect(() => {
    dispatch(getCountriesAsync());
  }, []);

  const handleCheckIn = (e) => {
    let myDate = new Date(e.getTime() - e.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];

    setStartCheckIn(e.getTime() - e.getTimezoneOffset() * 60000);
    let tm = moment(myDate).add(1, "days").format("yyyy-MM-DD");
    setState({ ...state, checkIn: myDate, checkOut: tm });

    delete formErrors["checkIn"];

    if (new Date(myDate) >= new Date(state.checkOut)) {
      setState({ ...state, checkOut: tm, checkIn: myDate });
      delete formErrors["checkIn"];
      delete formErrors["checkOut"];
    }
  };

  const handleCheckOut = (e) => {
    let myDate = new Date(e.getTime() - e.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];

    setState({ ...state, checkOut: myDate });
    delete formErrors["checkOut"];
    setStartCheckOut(e.getTime() - e.getTimezoneOffset() * 60000);
  };

  const handleInputChange = (e) => {
    setCity(e.target.value);
    setChanged(false);
    setState({
      ...state,
      city: "",
    });
  };

  const validate = () => {
    let errors = {};

    if (city?.trim() === "") {
      errors.city = "Please Enter City Name!";
    } else if (state.city === "") {
      errors.city = "Please Select a Valid City Name!";
    }
    if (state.checkIn === "") {
      errors.checkIn = "Please Select Check In Date!";
    }
    if (state.checkOut === "") {
      errors.checkOut = "Please Select Check Out Date!";
    }
    if (state?.Nationality === "" || state?.Nationality === undefined) {
      errors.Nationality = "Please Select Nationality!";
    }
    return errors;
  };

  const checkErrors = (e) => {
    let check = validate();
    let name = e.target.name;

    if (name in check) {
      setFormErrors({ ...formErrors, [name]: check[name] });
    } else {
      setFormErrors({ ...formErrors, [name]: "" });
    }
  };

  const hotelSearchData = (e) => {
    e.preventDefault();
    setFormErrors(validate());
    setIsSubmit(true);
  };

  const handleSelectChange = (e) => {
    setState({ ...state, Nationality: e.target.value });
  };
  const setGuests = (ind, key, type) => {
    if (key === "rooms") {
      return roomHandler(type);
    }
    let previousGuests = JSON.parse(JSON.stringify(guestDetails));

    if (type === "inc") {
      previousGuests[ind][key] = previousGuests[ind][key] + 1;
      if (key === "Children") {
        previousGuests[ind]["ChildrenAges"].push("1");
      }
    } else {
      previousGuests[ind][key] = previousGuests[ind][key] - 1;
      if (key === "Children") {
        previousGuests[ind]["ChildrenAges"].splice(-1);
      }
    }
    setGuestDetails(previousGuests);
  };

  const childAgeHandler = (e, ind, childind) => {
    var age = e.target.value;
    const previousGuests = [...guestDetails];
    previousGuests[ind]["ChildrenAges"][childind] = age;
    setGuestDetails(previousGuests);
  };

  useEffect(() => {}, [guestDetails]);

  const roomHandler = (type) => {
    if (type === "inc") {
      setGuestDetails([
        ...guestDetails,
        { Adults: 1, Children: 0, ChildrenAges: [] },
      ]);
    } else {
      setGuestDetails(guestDetails.slice(0, guestDetails.length - 1));
    }
  };

  const inputWidthHandler = (type) => {
    if (type === "focus") {
      setInputActive(true);
    } else {
      setInputActive(false);
    }
  };

  return (
    <Fragment>
      <div className="bf-wrap">
        <form className="bf-form">
          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="32"
                viewBox="0 0 26 32"
                fill="none"
              >
                <path
                  d="M12.8 16C11.04 16 9.6 14.56 9.6 12.8C9.6 11.04 11.04 9.6 12.8 9.6C14.56 9.6 16 11.04 16 12.8C16 14.56 14.56 16 12.8 16ZM22.4 13.12C22.4 7.312 18.16 3.2 12.8 3.2C7.44 3.2 3.2 7.312 3.2 13.12C3.2 16.864 6.32 21.824 12.8 27.744C19.28 21.824 22.4 16.864 22.4 13.12ZM12.8 0C19.52 0 25.6 5.152 25.6 13.12C25.6 18.432 21.328 24.72 12.8 32C4.272 24.72 0 18.432 0 13.12C0 5.152 6.08 0 12.8 0Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">City</label>
              <input
                type="search"
                className="bf-input"
                value={city}
                name="city"
                placeholder="Where are you going?"
                onChange={handleInputChange}
                onBlur={(e) => {
                  setListShow(false);
                  checkErrors(e);
                  inputWidthHandler("blur");
                }}
                onFocus={(e) => inputWidthHandler("focus")}
                autoComplete="off"
              />
              <span className="bf-error">{formErrors?.city}</span>

              <ul className={`bf-suggestions ${listShow ? "is-open" : ""}`}>
                {list.length > 0 ? (
                  list.map((ele, ind) => (
                    <li
                      onMouseDown={() => {
                        setCity(ele.name);
                        setState({ ...state, city: ele.city_code });
                        setListShow(false);
                      }}
                      key={ind}
                    >
                      {ele.name}
                    </li>
                  ))
                ) : (
                  <li className="bf-suggestions-empty">No Matches Found!</li>
                )}
              </ul>
            </div>
          </div>

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="32"
                viewBox="0 0 29 32"
                fill="none"
              >
                <path
                  d="M6.4 14.4H9.6V17.6H6.4V14.4ZM28.8 6.4V28.8C28.8 30.56 27.36 32 25.6 32H3.2C1.424 32 0 30.56 0 28.8L0.016 6.4C0.016 4.64 1.424 3.2 3.2 3.2H4.8V0H8V3.2H20.8V0H24V3.2H25.6C27.36 3.2 28.8 4.64 28.8 6.4ZM3.2 9.6H25.6V6.4H3.2V9.6ZM25.6 28.8V12.8H3.2V28.8H25.6ZM19.2 17.6H22.4V14.4H19.2V17.6ZM12.8 17.6H16V14.4H12.8V17.6Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">Check In</label>
              <DatePicker
                onChange={handleCheckIn}
                peekNextMonth
                showMonthDropdown
                selected={Date.parse(state.checkIn)}
                showYearDropdown
                dropdownMode="select"
                minDate={todayMinDate}
                maxDate={endDateAll}
                dateFormat="yyyy-MM-dd"
                name="checkIn"
                placeholderText={"CheckIn Date"}
                value={
                  state.checkIn !== "" ? slashFormatter(state.checkIn) : ""
                }
                className="bf-input"
                autoComplete="off"
                onBlur={(e) => checkErrors(e)}
              />
              <span className="bf-error">{formErrors?.checkIn}</span>
            </div>
          </div>

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="32"
                viewBox="0 0 29 32"
                fill="none"
              >
                <path
                  d="M6.4 14.4H9.6V17.6H6.4V14.4ZM28.8 6.4V28.8C28.8 30.56 27.36 32 25.6 32H3.2C1.424 32 0 30.56 0 28.8L0.016 6.4C0.016 4.64 1.424 3.2 3.2 3.2H4.8V0H8V3.2H20.8V0H24V3.2H25.6C27.36 3.2 28.8 4.64 28.8 6.4ZM3.2 9.6H25.6V6.4H3.2V9.6ZM25.6 28.8V12.8H3.2V28.8H25.6ZM19.2 17.6H22.4V14.4H19.2V17.6ZM12.8 17.6H16V14.4H12.8V17.6Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">Check Out</label>
              <DatePicker
                onChange={handleCheckOut}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                selected={Date.parse(state.checkOut)}
                minDate={Date.parse(moment(startCheckIn).add(1, "days"))}
                maxDate={endDateAll}
                dateFormat="yyyy-MM-dd"
                name="checkOut"
                placeholderText={"CheckOut Date"}
                value={
                  state.checkOut !== "" ? slashFormatter(state.checkOut) : ""
                }
                className="bf-input"
                autoComplete="off"
                onBlur={(e) => checkErrors(e)}
              />
              <span className="bf-error">{formErrors?.checkOut}</span>
            </div>
          </div>

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="33"
                viewBox="0 0 30 33"
                fill="none"
              >
                <path
                  d="M14.2222 33C12.2311 33 10.3704 32.6267 8.64 31.88C6.90963 31.1333 5.40444 30.12 4.12444 28.84C2.84444 27.56 1.83704 26.0489 1.10222 24.3067C0.367408 22.5644 0 20.6978 0 18.7067C0 16.7155 0.367408 14.8607 1.10222 13.1422C1.83704 11.4237 2.84444 9.92443 4.12444 8.64443C5.40444 7.36443 6.90963 6.36295 8.64 5.63999C10.3704 4.91702 12.2311 4.55554 14.2222 4.55554C14.7674 4.55554 15.3067 4.58517 15.84 4.64443C16.3733 4.70369 16.9007 4.79258 17.4222 4.9111V12.3067C17.0904 11.24 16.6519 10.2267 16.1067 9.26665C15.5615 8.30665 14.9333 7.44739 14.2222 6.68888C13.4637 7.32888 12.8237 8.17036 12.3022 9.21332C11.7807 10.2563 11.283 11.6667 10.8089 13.4444H17.4222V15.5778H10.4178C10.323 16.3126 10.2637 16.8992 10.24 17.3378C10.2163 17.7763 10.2044 18.2326 10.2044 18.7067C10.2044 19.2044 10.2163 19.6844 10.24 20.1467C10.2637 20.6089 10.323 21.2074 10.4178 21.9422H18.0622C18.157 21.2074 18.2163 20.6089 18.24 20.1467C18.2637 19.6844 18.2756 19.2044 18.2756 18.7067C18.2756 18.2326 18.2637 17.7763 18.24 17.3378C18.2163 16.8992 18.157 16.3126 18.0622 15.5778H20.2311C20.3022 16.4074 20.3496 17.0415 20.3733 17.48C20.397 17.9185 20.4089 18.3274 20.4089 18.7067C20.4089 19.2281 20.3911 19.72 20.3556 20.1822C20.32 20.6444 20.2667 21.2311 20.1956 21.9422H25.8844C26.0504 21.3733 26.163 20.8459 26.2222 20.36C26.2815 19.8741 26.3111 19.3229 26.3111 18.7067C26.3111 18.0904 26.2815 17.557 26.2222 17.1067C26.163 16.6563 26.0504 16.1467 25.8844 15.5778H28.1244C28.243 16.0755 28.3259 16.5852 28.3733 17.1067C28.4207 17.6281 28.4444 18.1615 28.4444 18.7067C28.4444 20.6978 28.077 22.5644 27.3422 24.3067C26.6074 26.0489 25.6 27.56 24.32 28.84C23.04 30.12 21.5348 31.1333 19.8044 31.88C18.0741 32.6267 16.2133 33 14.2222 33ZM2.56 21.9422H8.21333C8.14222 21.3022 8.10074 20.7274 8.08889 20.2178C8.07704 19.7081 8.07111 19.2044 8.07111 18.7067C8.07111 18.1141 8.08296 17.5867 8.10667 17.1244C8.13037 16.6622 8.17778 16.1467 8.24889 15.5778H2.56C2.39407 16.1467 2.28148 16.6563 2.22222 17.1067C2.16296 17.557 2.13333 18.0904 2.13333 18.7067C2.13333 19.3229 2.16296 19.8741 2.22222 20.36C2.28148 20.8459 2.39407 21.3733 2.56 21.9422ZM11.2 30.5111C10.6074 29.6104 10.0978 28.6385 9.67111 27.5955C9.24444 26.5526 8.88889 25.3792 8.60444 24.0755H3.27111C4.17185 25.7585 5.21481 27.08 6.4 28.04C7.58519 29 9.18519 29.8237 11.2 30.5111ZM3.27111 13.4444H8.64C8.90074 12.1644 9.23259 11.0207 9.63556 10.0133C10.0385 9.00591 10.5481 8.02813 11.1644 7.07999C9.38667 7.53036 7.83407 8.28888 6.50667 9.35554C5.17926 10.4222 4.10074 11.7852 3.27111 13.4444ZM14.2222 30.9378C15.0519 30.0844 15.7452 29.1067 16.3022 28.0044C16.8593 26.9022 17.3156 25.5926 17.6711 24.0755H10.8089C11.1407 25.4978 11.5852 26.7778 12.1422 27.9155C12.6993 29.0533 13.3926 30.0607 14.2222 30.9378ZM17.28 30.4755C18.9867 29.9304 20.5215 29.1126 21.8844 28.0222C23.2474 26.9318 24.3437 25.6163 25.1733 24.0755H19.8756C19.5674 25.3555 19.2059 26.517 18.7911 27.56C18.3763 28.6029 17.8726 29.5748 17.28 30.4755Z"
                  fill="currentColor"
                />
                <path
                  d="M26.7368 7.80393L26.7828 7.72819L26.7131 7.6734C26.3517 7.38915 25.9579 7.17556 25.5319 7.03316C25.1062 6.89085 24.6547 6.82 24.178 6.82C23.7013 6.82 23.2497 6.89085 22.824 7.03316C22.3981 7.17556 22.0042 7.38915 21.6428 7.6734L21.5732 7.72819L21.6192 7.80393C21.887 8.24461 22.2436 8.59761 22.688 8.86194C23.1347 9.12767 23.6321 9.26 24.178 9.26C24.7238 9.26 25.2213 9.12767 25.668 8.86194C26.1124 8.59761 26.469 8.24461 26.7368 7.80393ZM24.1121 13.8752L24.178 13.9329L24.2438 13.8752C25.9173 12.4105 27.1715 11.0465 28.0026 9.78296C28.8336 8.51967 29.2558 7.34063 29.2558 6.248C29.2558 4.62535 28.7473 3.32272 27.7235 2.35145C26.7051 1.38541 25.5219 0.9 24.178 0.9C22.834 0.9 21.6508 1.38541 20.6325 2.35145C19.6086 3.32273 19.1002 4.62535 19.1002 6.248C19.1002 7.34063 19.5223 8.51967 20.3533 9.78296C21.1845 11.0465 22.4386 12.4105 24.1121 13.8752ZM24.178 6.06C24.5062 6.06 24.7886 5.93943 25.0197 5.70171C25.2507 5.46408 25.3669 5.17495 25.3669 4.84C25.3669 4.50505 25.2507 4.21592 25.0197 3.97829C24.7886 3.74057 24.5062 3.62 24.178 3.62C23.8498 3.62 23.5674 3.74057 23.3363 3.97829C23.1052 4.21592 22.9891 4.50505 22.9891 4.84C22.9891 5.17495 23.1052 5.46408 23.3363 5.70171C23.5674 5.93943 23.8498 6.06 24.178 6.06ZM27.1499 8.97089C26.5087 9.99399 25.5195 11.1364 24.1788 12.3981C22.8681 11.1366 21.8857 9.99389 21.2288 8.97C20.5597 7.92714 20.2335 7.02093 20.2335 6.248C20.2335 5.01194 20.6171 4.00887 21.3794 3.22995C22.1434 2.44938 23.0742 2.06 24.178 2.06C25.2817 2.06 26.2126 2.44938 26.9765 3.22995C27.7388 4.00887 28.1224 5.01194 28.1224 6.248C28.1224 7.02155 27.8035 7.92808 27.1499 8.97089Z"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth="0.2"
                />
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">Nationality</label>
              <select
                name="Nationality"
                className="bf-select"
                value={state.Nationality}
                onChange={handleSelectChange}
                onBlur={(e) => checkErrors(e)}
              >
                {countryList !== undefined &&
                  countryList.map((ele, ind) => (
                    <option key={ind} value={ele.country_code}>
                      {ele.name}
                    </option>
                  ))}
              </select>
              <span className="bf-error">{formErrors?.Nationality}</span>
            </div>
          </div>

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="24"
                viewBox="0 0 32 24"
                fill="none"
              >
                <path
                  d="M22.793 13.2798C24.7857 14.6326 26.1821 16.4653 26.1821 18.9089V23.2726H32.0002V18.9089C32.0002 15.738 26.8075 13.8617 22.793 13.2798Z"
                  fill="currentColor"
                />
                <path
                  d="M20.3633 11.6364C23.5778 11.6364 26.1814 9.03273 26.1814 5.81818C26.1814 2.60364 23.5778 0 20.3633 0C19.6796 0 19.0396 0.145454 18.4287 0.349091C19.636 1.84727 20.3633 3.75273 20.3633 5.81818C20.3633 7.88364 19.636 9.78909 18.4287 11.2873C19.0396 11.4909 19.6796 11.6364 20.3633 11.6364Z"
                  fill="currentColor"
                />
                <path
                  d="M11.6365 11.6364C14.8511 11.6364 17.4547 9.03273 17.4547 5.81818C17.4547 2.60364 14.8511 0 11.6365 0C8.422 0 5.81836 2.60364 5.81836 5.81818C5.81836 9.03273 8.422 11.6364 11.6365 11.6364ZM11.6365 2.90909C13.2365 2.90909 14.5456 4.21818 14.5456 5.81818C14.5456 7.41818 13.2365 8.72727 11.6365 8.72727C10.0365 8.72727 8.72745 7.41818 8.72745 5.81818C8.72745 4.21818 10.0365 2.90909 11.6365 2.90909Z"
                  fill="currentColor"
                />
                <path
                  d="M11.6364 13.0909C7.75273 13.0909 0 15.04 0 18.9091V23.2727H23.2727V18.9091C23.2727 15.04 15.52 13.0909 11.6364 13.0909ZM20.3636 20.3636H2.90909V18.9236C3.2 17.8763 7.70909 16 11.6364 16C15.5636 16 20.0727 17.8763 20.3636 18.9091V20.3636Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="bf-control bf-guests">
              <label className="bf-label" htmlFor="">Guests &amp; Rooms</label>

              <ul
                className={`bf-panel ${ageDrop === "show" ? "show" : ""}`}
              >
                <li>
                  <div className="bf-panel-body">
                    <div className="bf-room-block">
                      <div className="bf-counter-row">
                        <div>
                          <h5 className="bf-counter-label">Rooms</h5>
                          <h6 className="bf-counter-sub">(Max 8)</h6>
                        </div>
                        <div>
                          <Counter
                            currentInd={0}
                            count={guestDetails.length}
                            callFunc={setGuests}
                            max={12}
                            min={1}
                            type="rooms"
                          />
                        </div>
                      </div>
                    </div>

                    {guestDetails.map((ele, ind) => (
                      <div className="bf-room-block" key={ind}>
                        <h6 className="bf-room-heading">Room {ind + 1}</h6>
                        <div className="bf-counter-row">
                          <div>
                            <h5 className="bf-counter-label">Adult</h5>
                          </div>
                          <div>
                            <Counter
                              currentInd={ind}
                              count={ele.Adults}
                              callFunc={setGuests}
                              max={12}
                              min={1}
                              type="Adults"
                            />
                          </div>
                        </div>
                        <div className="bf-counter-row">
                          <div>
                            <h5 className="bf-counter-label">Children</h5>
                            <h6 className="bf-counter-sub">(Aged 0-12 yrs)</h6>
                          </div>
                          <div>
                            <Counter
                              currentInd={ind}
                              count={ele.Children}
                              callFunc={setGuests}
                              max={4}
                              min={0}
                              type="Children"
                            />
                          </div>
                        </div>

                        <div className="bf-child-ages">
                          {ele.ChildrenAges.map((childage, childind) => (
                            <div className="bf-child-age" key={childind}>
                              <h5>Child {childind + 1} age</h5>
                              <select
                                className="bf-child-select"
                                defaultValue={childage}
                                onChange={(e) =>
                                  childAgeHandler(e, ind, childind)
                                }
                              >
                                {new Array(12)
                                  .fill(0)
                                  .map(function (loop, loopInd) {
                                    return (
                                      <option value={loopInd + 1} key={loopInd}>
                                        {loopInd + 1} Year
                                      </option>
                                    );
                                  })}
                              </select>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="bf-panel-footer">
                    <a className="bf-btn-apply" onClick={handleApplyBtn}>
                      Apply
                    </a>
                  </div>
                </li>
              </ul>

              <input
                className="bf-input"
                type="text"
                onFocus={() => setAgeDrop("show")}
                placeholder={placeHolder}
                readOnly
              />
            </div>
          </div>

          {/* search button */}
          <div className="bf-submit">
            <SearchButton func={hotelSearchData} />
          </div>
        </form>
      </div>
    </Fragment>
  );
};

export default HotelForm;